import React, { useContext, useEffect, useState } from "react";

import { Box, Grid, List, useTheme } from "@mui/material";

import RatingButtons from "components/listItems/RatingButtons/RatingButtons";
import Song from "components/listItems/Song/Song";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";

import { UserContext } from "utils/UserContext";

import PropTypes from "prop-types";

function SongScoringList({ audioRef, audioStatus, setAudioStatus }) {
  const { albumTracks } = useContext(UserContext);

  const mainTheme = useTheme();

  const [currentIndex, setCurrentIndex] = useState(0);

  const currentSong = albumTracks[currentIndex];

  useEffect(() => {
    if (audioStatus.isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [audioStatus, audioRef]);

  return (
    <Box component="section">
      <CenteredColumnGrid container>
        <Grid item>
          <Box>
            <audio
              ref={audioRef}
              src={
                currentSong.previewUrl === null ? "" : currentSong.previewUrl
              }
              onCanPlayThrough={() => {
                setAudioStatus((prev) => ({
                  ...prev,
                  isReady: true,
                }));
              }}
              preload="auto"
              onEnded={() => {
                setAudioStatus((prev) => ({
                  ...prev,
                  isReady: false,
                  isPlaying: false,
                }));
              }}
            />
            <track
              kind="captions"
              src="path/to/captions.vtt"
              srcLang="en"
              label="English"
            />
            <List
              sx={{
                padding: "5px",
                margin: "5px 0",
                backgroundColor: mainTheme.palette.darkGraySecondary.main,
                borderRadius: "1.25rem",
              }}
            >
              {albumTracks.map((song, idx) => (
                <Box
                  sx={{
                    bgcolor: mainTheme.palette.blackSecondary.main,
                    padding: "5px 0 15px 0",
                    margin: "20px",
                    borderRadius: "1.25rem",
                  }}
                  key={song.id}
                >
                  <Box component="li">
                    <Song
                      idx={idx}
                      currentIndex={currentIndex}
                      setCurrentIndex={setCurrentIndex}
                      songName={song.name}
                      currentSong={currentSong}
                      audioStatus={audioStatus}
                      setAudioStatus={setAudioStatus}
                      noAudio={currentSong.previewUrl === null}
                    />
                    <RatingButtons song={song} />
                  </Box>
                </Box>
              ))}
            </List>
          </Box>
        </Grid>
      </CenteredColumnGrid>
    </Box>
  );
}

SongScoringList.propTypes = {
  audioRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  audioStatus: PropTypes.shape({
    isPlaying: PropTypes.bool.isRequired,
    isReady: PropTypes.bool.isRequired,
  }).isRequired,
  setAudioStatus: PropTypes.func.isRequired,
};

export default SongScoringList;
